import ArtLamp from '../../src/legacy/ArtLamp';
export default ArtLamp;
